import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row, Spinner } from 'reactstrap';
import NewsAndArticleApi from '../../../Api/NewsAndArticleApi';
import { toast } from 'react-toastify';
import './ViewArticle.scss';

const ViewArticle = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const response = await NewsAndArticleApi.getNewsAndArticleById(id);
        if (response.data.success) {
          setArticle(response.data.data);
        } else {
          toast.error(response.data.message || 'Failed to fetch article');
          navigate('/news-and-articles');
        }
      } catch (error) {
        console.error('Error fetching article:', error);
        toast.error('Failed to fetch article');
        navigate('/news-and-articles');
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [id, navigate]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner color="primary" />
      </div>
    );
  }

  if (!article) {
    return null;
  }

  return (
    <div className="article-view-page">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} md={12}>
            <Card className="article-card">
              <CardBody>
                <div className="mb-4 d-flex justify-content-between align-items-center">
                  <h1 className="article-title">{article.title}</h1>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => navigate('/news-and-articles')}
                  >
                    Back to Articles
                  </button>
                </div>
                <div className="article-meta mb-4">
                  <div className="article-date text-muted">
                    {formatDate(article.createdAt)}
                  </div>
                  {article.authorDetails && (
                    <div className="article-author text-muted">
                      By {article.authorDetails.name} , {article.authorDetails.position}
                    </div>
                  )}
                </div>
                {article.image && (
                  <div className="article-image-container mb-4">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="article-image"
                    />
                  </div>
                )}
                <div 
                  className="article-content"
                  dangerouslySetInnerHTML={{ __html: article.content }}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ViewArticle; 